<template>
  
  <b-row v-if="esNeumologia">
    <b-col>
      <b-card
       
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA NEUMOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding:1.5rem 2rem">

            <InfoFuma/>

            <hr class="my-2">

            <DrogasVacunasSintomas/>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>

import { mapState }  from 'vuex';
import InfoFuma      from './InfoFuma.vue';
import DrogasVacunasSintomas from './DrogasVacunasSintomas.vue';

export default {
  name: "SemiologiaNeumologica",

  components: {
    InfoFuma, 
    DrogasVacunasSintomas,
  },

  data() {
    return {
      visibleBody: true,

    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    }
  },

  watch: {
    stSemNeumologica:{
      deep: true,
      handler(newValue){
        const semiologia = { tipo:'neumologica', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
      
    }
  },


  computed: {
    ...mapState({
      stSemNeumologica: state => state.atencionCita.semiologias?.semNeumologica,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esNeumologia(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000514';
    },
  }


}
</script>
